
  import { defineComponent, PropType } from 'vue';
  import { mapGetters } from 'vuex';

  import { VED_COMMON_GETTERS_NAME } from '../../store/vedCommon/name';
  import { TForeignTradeByProductsFilter } from '../../types/foreign-trade-by-products';
  import { getBaseTreeInfo } from '../../utils/base-info/tree';
  import BaseInfo from '../common/base-info/BaseInfo.vue';
  import { TBaseInfoItem } from '../common/base-info/types';

  export default defineComponent({
    name: 'ForeignTradeByProductsBaseInfo',
    components: {
      BaseInfo,
    },
    props: {
      filter: {
        type: Object as PropType<TForeignTradeByProductsFilter>,
        required: true,
      },
    },
    computed: {
      ...mapGetters({
        getCountriesTree: VED_COMMON_GETTERS_NAME.getCountriesTree,
        getRegionsRfTree: VED_COMMON_GETTERS_NAME.getRegionsRfTree,
      }),
      getItems(): TBaseInfoItem[] {
        return [this.getRegionsRfItem, this.getCountriesItem];
      },
      getRegionsRfItem(): TBaseInfoItem {
        return {
          label: 'Субъект РФ',
          value: getBaseTreeInfo(this.getRegionsRfTree, this.filter.regionsRf),
          isLoading: !this.getRegionsRfTree.length,
        };
      },
      getCountriesItem(): TBaseInfoItem {
        return {
          label: 'Страна-партнер',
          value: getBaseTreeInfo(this.getCountriesTree, this.filter.countries),
          isLoading: !this.getCountriesTree.length,
        };
      },
    },
  });
